module.exports = __webpack_public_path__ + "img/wx-tip.png";